import React, { useState } from "react";
import { BASE_URL } from "../utils/config";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button

} from "@mui/material";

import Loading from "../components/loading";


const StockGTTable = ({ RecordData, heading, updaterecord,updateRecordData, handleUpdateChild,Email }) => {
    const navigate = useNavigate();
    const columns = [

        { id: "S.No", label: "S.No", minWidth: 40 },
        { id: "symbol", label: "Stock Symbol", minWidth: 110 },
        { id: "GenralTrend", label: "Trend", minWidth: 100 },
        { id: "UserName", label: "Changed By", minWidth: 120 },
        { id: "modified_at", label: "Changed At", minWidth: 90 },
        { id: "Action", label: "Action", minWidth: 70 },
    ];

    const [editRecord, setEditRecord] = useState({});
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(25);

    const [filteredRecord, setfilteredRecord] = useState([]);

    const [selectedItems, setSelectedItems] = useState({});
    const [updatedialog,setUpdateDialog]=useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
 




    //  handle page change for pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        let startindex = newPage * rowsPerPage;
        console.log("startindex", startindex);
        let endindex = Math.min(startindex + rowsPerPage, RecordData.length);
        console.log("endindex", endindex);
        setStartIndex(startindex);
        setEndIndex(endindex);
    };

    // handle row change in page
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setEndIndex(+event.target.value);
        setStartIndex(0);
        setPage(0);
    };

    //  hanlde api call to update the record
    const handleUpdate = async () => {
        console.log("inside form submit")
        setLoading(true)
        setUpdateDialog(false);
        console.log("edit record",editRecord)
        console.log("selected record",selectedItems)
        if(editRecord.id === selectedItems.id){ 
            if(editRecord.GenralTrend !== selectedItems.GenralTrend){
        const details = JSON.parse(localStorage.getItem('loginData'));
       
        let body = JSON.stringify({
            GenralTrend: selectedItems.GenralTrend,
            modifiedBy: details.user_id
        })

        console.log("inside form submit", body)
        await fetch(`${BASE_URL}/updateStockgtandsr/GT/${selectedItems.id}`, {
            method: 'PUT',
            body: body,
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${details.token}`
            },
        })
            .then(response => response.json())
            .then(res => {
                // Process the API response data
                console.log("GT Response ===================res ", res);

                if (res.status === 200) {
                    setLoading(false)
                    setSuccessMessage('Stock GT Updated Successfully.')
                    setSuccessDialog(true)
                    handleUpdateChild()
                    setTimeout(() => {
                        
                        setSuccessDialog(false)
                        setSuccessMessage('')
                        setEditRecord({})
                        setSelectedItems({})

                    }, 2000)
                } else if (res.status === 403) {
                    setErrorMessage(`Error: ${res.message}`)
                    setErrorDialog(true)
                    setTimeout(() => {
                        setErrorDialog(false)
                        setErrorMessage('')
                        localStorage.clear()
                        navigate('/login')
                    }, 2000)
                }
                else if (res.status === 401) {

                    setErrorMessage(`Error: ${res.message}`)
                    setErrorDialog(true)
                    setTimeout(() => {
                        setErrorDialog(false)
                        setErrorMessage('')
                        localStorage.clear()
                        navigate('/login')
                    }, 2000)
                } else {
                    setLoading(false)

                    setErrorMessage(`Error: ${res.message}`)
                    setErrorDialog(true)
                    setTimeout(() => {
                        setErrorDialog(false)
                        setErrorMessage('')
                    }, 2000)
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setLoading(false)
                setErrorMessage(`Error: ${error.message}`)
                setErrorDialog(true)
                setTimeout(() => {
                    setErrorDialog(false)
                    setErrorMessage('')
                }, 2000)
            });
        }else{
            setLoading(false)
            setErrorMessage(`Please Change Value To Call Update.`)
            setErrorDialog(true)
            setTimeout(() => {
                setErrorDialog(false)
                setErrorMessage('')
                setEditRecord({})
                        setSelectedItems()
            }, 2000)
        }
        }else{
            setLoading(false)
            setErrorMessage(`Please Change Value To Call Update.`)
            setErrorDialog(true)
            setTimeout(() => {
                setErrorDialog(false)
                setErrorMessage('')
                setEditRecord({})
                        setSelectedItems()
            }, 2000)  
        }
    }


//  hide dialog box for remove row
const hideUpdateDialog = () => {
    setUpdateDialog(false);
  };

  const UpdateRecordGT = async (row) =>{
    console.log("deleted")
    setSelectedItems(row)
    setUpdateDialog(true);
  }

  const handlechangeGT = (id, newValue)=>{
    const record = RecordData.find(item => item.id === id);
    if (!record) return;
  
    const currentValue = record.GenralTrend;
  
    if (currentValue === newValue) {
      // No change → skip API call
      return;
    }else{

    setEditRecord(record)
    updateRecordData(id, newValue)
    }
  }

    const renderGTDropDown = (row) => {
    
        return (
            <div >
                <select
                    
                    value={row.GenralTrend}
                    onChange={(e) => handlechangeGT(row.id,e.target.value)}
                >
                    <option value="BUY">BUY</option>
                    <option value="SELL">SELL</option>
                </select>
            
            </div>
        )
    }

    const formatDateTime = (row)=>{
        console.log("row.datetome",row.modified_at)
        const utcDate = new Date(row.modified_at);
        console.log("isbadet",utcDate) 
       
        const date = utcDate.toLocaleDateString("en-IN", {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      
        const time = utcDate.toLocaleTimeString("en-IN", {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
        
        return (
            <div>
                <p style={{marginBottom:'0px'}}>Date: {date}</p>
                <p style={{marginBottom:'0px'}}>Time: {time}</p>
            </div>
        )
    }

    return (
        <>
            <Sidebar />
            {loading ? (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                    }}
                >
                    <Loading />
                </div>
            ) : (
                <div >

                    <div className="container-fluid">
                        <div className="table">
                            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                                <TableContainer sx={{ maxHeight: 370 }}>
                                    <Table
                                        style={{ margin: 0 }}
                                        stickyHeader
                                        aria-label="sticky table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column, index) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}

                                                        style={{
                                                            textAlign: "center",
                                                            minWidth: column.minWidth,
                                                            backgroundColor: "#23499E",
                                                            color: "white",
                                                        }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        {RecordData.length > 0 ? (
                                            <TableBody>
                                                {RecordData
                                                    .slice(startIndex, endIndex)
                                                    .map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row.code}
                                                            >
                                                                {columns.map((column) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            style={{
                                                                                position: "sticky",
                                                                                backgroundColor: "#fff",
                                                                             
 
                                                                            }}
                                                                            class="table-cell-screenerTab"
                                                                            key={column.id}
                                                                            align={column.align}
                                                                        >
                                                                            {column.id === "S.No" ? (
                                                                                index + 1
                                                                            ) : column.id === "Action" ? (
                                                                                <div >
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            UpdateRecordGT(row)
                                                                                        }>
                                                                                        Update
                                                                                    </button>


                                                                                </div>
                                                                            ) : column.id === "GenralTrend" ? (
                                                                                renderGTDropDown(row)
                                                                            
                                                                            ) : column.id === "modified_at" ? (
                                                                                formatDateTime(row)
                                                                            )
                                                                                : (
                                                                                    value
                                                                                )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                            </TableBody>
                                        ) : null}
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75, 100]}
                                    component="div"
                                    count={filteredRecord.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </div>
                    </div>



                    {/*Error Message Dialog */}
                    <Dialog
                        open={errorDialog}
                        onClose={() => { setErrorDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "red" }}>Failure</h4>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                {errorMessage}


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>

                    {/*Success Message Dialog */}
                    <Dialog
                        open={successDialog}
                        onClose={() => { setSuccessDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "green" }}>Success</h4>

                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                <span style={{ color: "black" }}>
                                    {successMessage}
                                </span>


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>


                     {/*Remove all  dialog */}
                              <Dialog
                                open={updatedialog}
                                onClose={hideUpdateDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                              >
                                <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
                                  {"Confirm Update"}
                                </DialogTitle>
                                <DialogContent>
                                  <DialogContentText id="alert-dialog-description">
                                    
                                      <span style={{ color: "black" }}>
                                        Are you sure, you want to Update This Stock GT. 
                                      </span>
                                 
                                  </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                  <Button className="btn-cancel"
                                    variant="outlined"
                                    color="error"
                                    onClick={hideUpdateDialog}
                                  >
                                    No
                                  </Button>
                                  <Button className="btn-submit"
                                    variant="outlined"
                                    color="success"
                                    onClick={handleUpdate}
                                    autoFocus
                                  >
                                    Yes
                                  </Button>
                                </DialogActions>
                              </Dialog>

                   


                </div>
            )}
        </>
    );
};

export default StockGTTable;

